import { z } from "zod";

import { LIQUIDITY_NEEDS_VALUES } from "~/v2/api/rest/account";
import { MARITAL_STATUS_VALUES } from "../../constant";

export const zFinancialProfile = z.object({
  annual_income_max: z.number().nonnegative(),
  annual_income_min: z.number().nonnegative(),
  liquid_net_worth_max: z.number().nonnegative(),
  liquid_net_worth_min: z.number().nonnegative(),
  total_net_worth_max: z.number().nonnegative(),
  total_net_worth_min: z.number().nonnegative(),
});

export const zImportanceQuestion = z.object({
  liquidity_needs: z.enum(LIQUIDITY_NEEDS_VALUES),
});

export const zMaritalStatus = z.object({
  marital_status: z.enum(MARITAL_STATUS_VALUES),
  number_of_dependents: z
    .number({ error: "Please input number" })
    .int({ message: "Must be integer" })
    .nonnegative({ message: "Cannot be negative" })
    .max(999),
});

export const zFinancialProfileForm = zFinancialProfile
  .merge(zImportanceQuestion)
  .merge(zMaritalStatus);

export type FinancialProfileForm = z.infer<typeof zFinancialProfileForm>;
